/**
 * UI — legendă dinamică, selector variabilă, responsive helpers.
 */
import {
  drawLegendGradient,
  getCategoriesForVariable,
  THRESHOLDS,
  LABELS,
  UNITS,
} from './colormaps.js';

/**
 * Actualizează panoul legendă pentru variabila curentă.
 */
export function updateLegend(variable) {
  const canvas = document.getElementById('legend-canvas');
  drawLegendGradient(canvas, variable);

  // Titlu
  const label = LABELS[variable] || variable;
  const unit = UNITS[variable] || '';
  document.getElementById('legend-title').textContent = `${label} (${unit})`;

  // Tick-uri
  const thresholds = THRESHOLDS[variable] || [];
  const ticksEl = document.getElementById('legend-ticks');
  ticksEl.innerHTML = '';

  // Afișăm doar câteva tick-uri (top, middle, bottom)
  const minVal = thresholds[0] || 0;
  const maxVal = thresholds[thresholds.length - 1] || 100;
  const midVal = Math.round((minVal + maxVal) / 2);
  const tickValues = [maxVal, midVal, minVal];

  tickValues.forEach(v => {
    const span = document.createElement('span');
    span.textContent = formatValue(v);
    ticksEl.appendChild(span);
  });

  // Categorii
  const catsEl = document.getElementById('legend-categories');
  catsEl.innerHTML = '';

  const categories = getCategoriesForVariable(variable);
  for (let i = categories.length - 1; i >= 0; i--) {
    const div = document.createElement('div');
    div.className = 'legend-cat';
    div.innerHTML = `
      <span class="legend-cat-dot" style="background: ${categories[i].color}"></span>
      <span>${categories[i].label}</span>
    `;
    catsEl.appendChild(div);
  }
}

/**
 * Actualizează afișajul run date.
 */
export function updateRunInfo(runDate) {
  const el = document.getElementById('run-date-display');
  if (runDate) {
    el.textContent = runDate;
  }
}

/**
 * Ascunde overlay-ul de loading.
 */
export function hideLoading() {
  const el = document.getElementById('loading-overlay');
  el.classList.add('hidden');
}

/**
 * Afișează overlay-ul de loading.
 */
export function showLoading() {
  const el = document.getElementById('loading-overlay');
  el.classList.remove('hidden');
}

/**
 * Inițializează event listeners UI.
 */
export function initUI(onVariableChange, onWindToggle) {
  // Layer menu buttons (Ventusky/Windy style)
  const layerBtns = document.querySelectorAll('#layer-menu .layer-btn');
  const windCheckbox = document.getElementById('wind-overlay-checkbox');

  layerBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const variable = btn.dataset.var;
      // Remove active from all
      layerBtns.forEach(b => b.classList.remove('active'));
      // Activate clicked
      btn.classList.add('active');

      // Dacă selectăm layer-ul wind_speed, auto-activăm overlay-ul
      if (variable === 'wind_speed' && windCheckbox && !windCheckbox.checked) {
        windCheckbox.checked = true;
        if (onWindToggle) onWindToggle(true);
      }

      onVariableChange(variable);
    });
  });

  // Wind overlay toggle — independent de selecția layer-ului
  if (windCheckbox && onWindToggle) {
    windCheckbox.addEventListener('change', () => {
      onWindToggle(windCheckbox.checked);
    });
  }

  // Buton close pixel panel
  document.getElementById('pixel-close').addEventListener('click', () => {
    document.getElementById('pixel-panel').classList.add('hidden');
  });

  // Resize handler pentru chart
  window.addEventListener('resize', () => {
    // Importăm lazy pentru a evita circular deps
    import('./chart.js').then(m => m.resizeChart());
  });
}

/**
 * Afișează grupul de layere meteo (când weather store e disponibil).
 */
export function showWeatherLayers() {
  const group = document.getElementById('weather-layer-group');
  if (group) {
    group.classList.remove('hidden');
  }
}

// ── Helpers ──────────────────────────────────────────────────────
function formatValue(v) {
  if (v >= 10000) return `${(v / 1000).toFixed(0)}k`;
  if (v >= 1000) return `${(v / 1000).toFixed(1)}k`;
  return String(Math.round(v));
}
